import axios from 'axios'
import { getAPIService } from '../../../getServerHost'
import { Id } from '../../../hip/types'

export const deleteFile = async (payload: { id: Id; type: string }) => {
  const { id, type } = payload
  const response = await axios.delete(`${getAPIService}/${type}/${id}`)
  return response.data
}
